import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/studio-sales-view")({
  beforeLoad: () => {
    throw redirect({ to: "/studio-showroom", statusCode: 301 });
  },
});
